import React, { Component } from 'react';
import classes from './Layout.module.scss';

import Intro from '../Intro/Intro';
import Survey from '../Survey/Survey';
import Quote from '../Quote/Quote';
import Aux from '../../hoc/Aux';
import {connect} from "react-redux";

class Layout extends Component {

    render() {

        let colorScheme;

        let QuestionsData = require( '../../data/' + this.props.mode + '-questions.js' );

        if( this.props.current_question_index < QuestionsData[ this.props.version ].length ) {
            colorScheme = QuestionsData[ this.props.version ][this.props.current_question_index].color_scheme;
        } else {
            colorScheme = 'default';
        }

        return (
            <Aux>
                { ( this.props.intro ) ? (
                    <div className={[classes.Layout,classes['BG-default']].join(' ')}>
                        <h1 id="bf-instant-quote-heading" className={classes.HeadingInstantQuote}>Instant Quote</h1>
                        <Intro />
                    </div>
                ) : (
                    <div className={[classes.Layout,classes['BG-' + colorScheme]].join(' ')}>
                        <h1 id="bf-instant-quote-heading" className={classes.HeadingInstantQuote}>Instant Quote</h1>
                        { ( this.props.current_question_index < QuestionsData[ this.props.version ].length ) ? (
                            <Survey />
                        ) : (
                            <Quote mode={this.props.mode} />
                        ) }
                    </div>
                ) }
            </Aux>
        );

    }

}

const mapStateToProps = state => {
    return {
        current_question_index: state.current_question_index,
        intro: state.intro,
        version: state.version,
        mode: state.mode,
    }
};

export default connect( mapStateToProps )( Layout );